import { render, staticRenderFns } from "./DataGatheringCard.vue?vue&type=template&id=7bc53307&scoped=true&"
import script from "./DataGatheringCard.vue?vue&type=script&lang=js&"
export * from "./DataGatheringCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc53307",
  null
  
)

export default component.exports